@if (!invisible) {
  @if (isH5) {
    <div class="left-menu-container full" [@h5-show]="state">
      <ng-container *ngIf="state || !closed" [ngTemplateOutlet]="full"></ng-container>
    </div>
  } @else {
    <div class="left-menu-container full" [@show]="state">
      <ng-container *ngIf="state || !closed" [ngTemplateOutlet]="full"></ng-container>
    </div>

    <div class="left-menu-container rail" [@show]="!state">
      <ng-container *ngIf="!state || !opened" [ngTemplateOutlet]="rail"></ng-container>
    </div>
  }
}

<ng-template #full>
  <ng-container
    *ngIf="opened"
    [ngTemplateOutlet]="menuTrigger"
    [ngTemplateOutletContext]="{ isExpanded: true }"
  ></ng-container>

  <div [style.margin-top.px]="16">
    @if (logined) {
      <app-left-menu-profile-info />
    }
  </div>

  <div class="menu-body">
    <app-scrollbar #scrollbar>
      <div class="menu-scroll-container">
        <div class="menu-list-wrapper">
          <div class="menu-list">
            @for (item of leftMenu; track $index) {
              <ng-container
                *ngTemplateOutlet="menuItemCategory; context: { item: item, level: 1, isFirst: $index == 0 }"
              ></ng-container>
            }
            <!-- TODO:體育上線後可刪除 -->
            <!-- <a href="" class="level1 menu-item onact96 disabled">
              <div class="decorate"></div>
              <div class="left" style="position: static">
                <div class="badge-wrapper">
                  <i class="icon fi-basketball-filled"></i>
                </div>
                <span>Sports</span>
                <em class="coming-soon">Coming soon</em>
              </div>
            </a> -->
          </div>
          <div class="menu-list">
            @for (defaultItem of defaultMenuData | slice: 0 : 3; track $index) {
              <ng-container
                *ngTemplateOutlet="menuItemCategory; context: { item: defaultItem, level: 1 }"
              ></ng-container>
            }
          </div>
          <div class="menu-list">
            @for (defaultItem of defaultMenuData | slice: 3; track $index) {
              <ng-container
                *ngTemplateOutlet="menuItemCategory; context: { item: defaultItem, level: 1 }"
              ></ng-container>
            }
          </div>
        </div>
        <div class="menu-payments-wrapper">
          <div class="menu-payment-icons">
            <img src="assets/images/media/brand/payment-provider-logos/visa.white.svg" alt="VISA" />
            <img src="assets/images/media/brand/payment-provider-logos/mastercard.colour.svg" alt="Mastercard" />
            <img src="assets/images/media/brand/payment-provider-logos/apple-pay.white.svg" alt="Apple Pay" />
            <img src="assets/images/media/brand/payment-provider-logos/google-pay.white.svg" alt="Google Pay" />
          </div>
          <cs-button
            (buttonClick)="walletService.jump('deposit', 'buyCrypto')"
            [label]="'Deposit Now'"
            [color]="'accent'"
            [size]="'small'"
          />
        </div>
      </div>
    </app-scrollbar>
  </div>
</ng-template>

<ng-template #rail>
  <ng-container
    *ngIf="!opened"
    [ngTemplateOutlet]="menuTrigger"
    [ngTemplateOutletContext]="{ isExpanded: false }"
  ></ng-container>

  <div class="menu-body">
    <app-scrollbar #scrollbar>
      <div class="menu-scroll-container">
        <div class="menu-list-wrapper">
          <!-- 第一組菜單 -->
          <div class="menu-list">
            @for (item of leftMenu; track $index) {
              @if (item.infoExpandList && item.infoExpandList.length > 0) {
                <div [class.rail-menu-accordion]="true" [class.expanded]="item.expand">
                  <div
                    class="rail-a"
                    cdkOverlayOrigin
                    #origin="cdkOverlayOrigin"
                    (mouseenter)="item.tooltip = true"
                    (mouseleave)="item.tooltip = false"
                    (click)="$event.stopPropagation(); clickMenu(item); $event.preventDefault()"
                  >
                    <div class="onact96 rail-menu-item level1" [class.active]="item.expand">
                      <div class="badge-wrapper">
                        @if (item.menuIcon.startsWith('https')) {
                          <img [src]="item.menuIcon" />
                        } @else {
                          <i [class]="item.menuIcon"></i>
                        }
                      </div>
                    </div>
                  </div>
                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="origin"
                    [cdkConnectedOverlayPositions]="railPositions"
                    [cdkConnectedOverlayOpen]="item.tooltip && !item.expand"
                  >
                    <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
                      {{ item.name }}
                    </div>
                  </ng-template>
                  @if (item.expand && item.infoExpandList) {
                    <div class="rail-submenu-group">
                      @for (subItem of item.infoExpandList; track $index) {
                        @if (!checkDisabled(subItem)) {
                          <div
                            class="rail-a"
                            cdkOverlayOrigin
                            #subOrigin="cdkOverlayOrigin"
                            (mouseenter)="subItem.tooltip = true"
                            (mouseleave)="subItem.tooltip = false"
                            (click)="$event.stopPropagation(); clickMenu(subItem); $event.preventDefault()"
                            [class.has-bottom-border]="subItem.hasBotLine"
                          >
                            <div
                              class="rail-menu-item level2 onact96"
                              [class.active]="subItem.activeRoutePath | routerActive: 'include'"
                            >
                              <div class="badge-wrapper">
                                @if (subItem.menuIcon.startsWith('https')) {
                                  <img [src]="subItem.menuIcon" />
                                } @else {
                                  <i [class]="subItem.menuIcon"></i>
                                }
                              </div>
                            </div>
                          </div>
                          <ng-template
                            cdkConnectedOverlay
                            [cdkConnectedOverlayOrigin]="subOrigin"
                            [cdkConnectedOverlayPositions]="railPositions"
                            [cdkConnectedOverlayOpen]="subItem.tooltip"
                          >
                            <div
                              class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none"
                            >
                              {{ subItem.name || subItem.labelName }}
                            </div>
                          </ng-template>
                        }
                      }
                    </div>
                  }
                </div>
              } @else {
                <div
                  class="rail-a"
                  cdkOverlayOrigin
                  #origin="cdkOverlayOrigin"
                  (mouseenter)="item.tooltip = true"
                  (mouseleave)="item.tooltip = false"
                  (click)="$event.stopPropagation(); clickMenu(item); $event.preventDefault()"
                >
                  <div
                    class="onact96 rail-menu-item level1"
                    [class.active]="item.activeRoutePath | routerActive: 'include'"
                  >
                    <div class="badge-wrapper">
                      @if (item.menuIcon.startsWith('https')) {
                        <img [src]="item.menuIcon" />
                      } @else {
                        <i [class]="item.menuIcon"></i>
                      }
                    </div>
                  </div>
                </div>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin"
                  [cdkConnectedOverlayPositions]="railPositions"
                  [cdkConnectedOverlayOpen]="item.tooltip"
                >
                  <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
                    {{ item.name }}
                  </div>
                </ng-template>
              }
            }
          </div>
          <!-- 第二組菜單 -->
          <div class="menu-list">
            @for (defaultItem of defaultMenuData | slice: 0 : 3; track $index) {
              <!-- 👇 添加 needLogined 判斷 -->
              @if (!defaultItem.needLogined || logined) {
                @if (defaultItem.infoExpandList && defaultItem.infoExpandList.length > 0) {
                  <div [class.rail-menu-accordion]="true" [class.expanded]="defaultItem.expand">
                    <div
                      class="rail-a"
                      cdkOverlayOrigin
                      #origin="cdkOverlayOrigin"
                      (mouseenter)="defaultItem.tooltip = true"
                      (mouseleave)="defaultItem.tooltip = false"
                      (click)="$event.stopPropagation(); clickMenu(defaultItem); $event.preventDefault()"
                    >
                      <div class="onact96 rail-menu-item level1" [class.active]="defaultItem.expand">
                        <div class="badge-wrapper">
                          @if (defaultItem.menuIcon.startsWith('https')) {
                            <img [src]="defaultItem.menuIcon" />
                          } @else {
                            <i [class]="defaultItem.menuIcon"></i>
                          }
                        </div>
                      </div>
                    </div>
                    <ng-template
                      cdkConnectedOverlay
                      [cdkConnectedOverlayOrigin]="origin"
                      [cdkConnectedOverlayPositions]="railPositions"
                      [cdkConnectedOverlayOpen]="defaultItem.tooltip && !defaultItem.expand"
                    >
                      <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
                        {{ defaultItem.name }}
                      </div>
                    </ng-template>
                    @if (defaultItem.expand && defaultItem.infoExpandList) {
                      <div class="rail-submenu-group">
                        @for (subItem of defaultItem.infoExpandList; track $index) {
                          <!-- 👇 子項目也要判斷 needLogined -->
                          @if (!subItem.needLogined || logined) {
                            <div
                              class="rail-a"
                              cdkOverlayOrigin
                              #subOrigin="cdkOverlayOrigin"
                              (mouseenter)="subItem.tooltip = true"
                              (mouseleave)="subItem.tooltip = false"
                              (click)="$event.stopPropagation(); clickMenu(subItem); $event.preventDefault()"
                            >
                              <div
                                class="rail-menu-item level2 onact96"
                                [class.active]="subItem.activeRoutePath | routerActive: 'include'"
                              >
                                <div class="badge-wrapper">
                                  @if (subItem.menuIcon.startsWith('https')) {
                                    <img [src]="subItem.menuIcon" />
                                  } @else {
                                    <i [class]="subItem.menuIcon"></i>
                                  }
                                </div>
                              </div>
                            </div>
                            <ng-template
                              cdkConnectedOverlay
                              [cdkConnectedOverlayOrigin]="subOrigin"
                              [cdkConnectedOverlayPositions]="railPositions"
                              [cdkConnectedOverlayOpen]="subItem.tooltip"
                            >
                              <div
                                class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none"
                              >
                                {{ subItem.name }}
                              </div>
                            </ng-template>
                          }
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <div
                    class="rail-a"
                    cdkOverlayOrigin
                    #origin="cdkOverlayOrigin"
                    (mouseenter)="defaultItem.tooltip = true"
                    (mouseleave)="defaultItem.tooltip = false"
                    (click)="$event.stopPropagation(); clickMenu(defaultItem); $event.preventDefault()"
                  >
                    <div
                      class="onact96 rail-menu-item level1"
                      [class.active]="defaultItem.activeRoutePath | routerActive: 'include'"
                    >
                      <div class="badge-wrapper">
                        @if (defaultItem.hasBadge) {
                          <div class="badge-container"></div>
                        }
                        @if (defaultItem.menuIcon.startsWith('https')) {
                          <img [src]="defaultItem.menuIcon" />
                        } @else {
                          <i [class]="defaultItem.menuIcon"></i>
                        }
                      </div>
                    </div>
                  </div>
                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="origin"
                    [cdkConnectedOverlayPositions]="railPositions"
                    [cdkConnectedOverlayOpen]="defaultItem.tooltip"
                  >
                    <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
                      {{ defaultItem.name }}
                    </div>
                  </ng-template>
                }
              }
            }
          </div>
          <!-- 第三組菜單 -->
          <div class="menu-list">
            @for (defaultItem of defaultMenuData | slice: 3; track $index) {
              <!-- 👇 添加 needLogined 判斷 -->
              @if (!defaultItem.needLogined || logined) {
                @if (defaultItem.infoExpandList && defaultItem.infoExpandList.length > 0) {
                  <div [class.rail-menu-accordion]="true" [class.expanded]="defaultItem.expand">
                    <div
                      class="rail-a"
                      cdkOverlayOrigin
                      #origin="cdkOverlayOrigin"
                      (mouseenter)="defaultItem.tooltip = true"
                      (mouseleave)="defaultItem.tooltip = false"
                      (click)="$event.stopPropagation(); clickMenu(defaultItem); $event.preventDefault()"
                    >
                      <div class="onact96 rail-menu-item level1" [class.active]="defaultItem.expand">
                        <div class="badge-wrapper">
                          @if (defaultItem.menuIcon.startsWith('https')) {
                            <img [src]="defaultItem.menuIcon" />
                          } @else {
                            <i [class]="defaultItem.menuIcon"></i>
                          }
                        </div>
                      </div>
                    </div>
                    <ng-template
                      cdkConnectedOverlay
                      [cdkConnectedOverlayOrigin]="origin"
                      [cdkConnectedOverlayPositions]="railPositions"
                      [cdkConnectedOverlayOpen]="defaultItem.tooltip && !defaultItem.expand"
                    >
                      <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
                        {{ defaultItem.name }}
                      </div>
                    </ng-template>
                    @if (defaultItem.expand && defaultItem.infoExpandList) {
                      <div class="rail-submenu-group">
                        @for (subItem of defaultItem.infoExpandList; track $index) {
                          <!-- 👇 子項目也要判斷 needLogined -->
                          @if (!subItem.needLogined || logined) {
                            <div
                              class="rail-a"
                              cdkOverlayOrigin
                              #subOrigin="cdkOverlayOrigin"
                              (mouseenter)="subItem.tooltip = true"
                              (mouseleave)="subItem.tooltip = false"
                              (click)="$event.stopPropagation(); clickMenu(subItem); $event.preventDefault()"
                            >
                              <div
                                class="rail-menu-item level2 onact96"
                                [class.active]="subItem.activeRoutePath | routerActive: 'include'"
                              >
                                <div class="badge-wrapper">
                                  @if (subItem.menuIcon.startsWith('https')) {
                                    <img [src]="subItem.menuIcon" />
                                  } @else {
                                    <i [class]="subItem.menuIcon"></i>
                                  }
                                </div>
                              </div>
                            </div>
                            <ng-template
                              cdkConnectedOverlay
                              [cdkConnectedOverlayOrigin]="subOrigin"
                              [cdkConnectedOverlayPositions]="railPositions"
                              [cdkConnectedOverlayOpen]="subItem.tooltip"
                            >
                              <div
                                class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none"
                              >
                                {{ subItem.name }}
                              </div>
                            </ng-template>
                          }
                        }
                      </div>
                    }
                  </div>
                } @else {
                  <ng-container
                    *ngTemplateOutlet="railMenuItem; context: { item: defaultItem, level: 1 }"
                  ></ng-container>
                }
              }
            }
          </div>
        </div>

        <a class="rail-menu-item level1" (click)="walletService.jump('deposit', 'buyCrypto')">
          <div>
            <i class="icon fi-cash"></i>
          </div>
        </a>
      </div>
    </app-scrollbar>
  </div>
</ng-template>

<!-- Menu Trigger Toggle -->
<ng-template #menuTrigger let-isExpanded="isExpanded">
  @if (!isH5) {
    <div
      (click)="turn(!isExpanded)"
      class="menu-trigger animate__animated animate__faster animate__fadeIn animate__fill_none"
      [ngClass]="{
        'menu-trigger--open': !isExpanded,
        'menu-trigger--close': isExpanded,
        'menu-trigger--h5': isH5,
      }"
    >
      <cs-button [label]="''" [color]="'third'" [size]="'small'" [iconLeft]="'fi-menu-alt-2'"></cs-button>
    </div>
  }
</ng-template>

<!-- 【收缩时】菜单 item 模板 -->
<ng-template #railMenuItem let-item="item" let-level="level">
  @if (item.options) {
    <ng-container *ngTemplateOutlet="railOptions; context: { item: item }"></ng-container>
  } @else if (item.special) {
    <ng-container [ngSwitch]="item.ident">
      <ng-container
        *ngSwitchCase="'theme-switch'"
        [ngTemplateOutlet]="railThemeSwitch"
        [ngTemplateOutletContext]="{ theme: appService.themeSwitch$ | async, item: item }"
      ></ng-container>
      <ng-container
        *ngSwitchCase="'langSelect'"
        [ngTemplateOutlet]="railOptions"
        [ngTemplateOutletContext]="{ item: item }"
      ></ng-container>
    </ng-container>
  } @else {
    <div
      class="rail-a"
      [class.disabled]="checkDisabled(item)"
      (click)="$event.stopPropagation(); clickRailMenu(item); $event.preventDefault()"
    >
      <div
        [class]="'onact96 rail-menu-item ' + (item.ident || '') + ' ' + (item.class || '') + ' level' + level"
        [class.active]="item.activeRoutePath | routerActive: 'full'"
        cdkOverlayOrigin
        #origin="cdkOverlayOrigin"
        (mouseenter)="item.tooltip = true"
        (mouseleave)="item.tooltip = false"
      >
        <div class="badge-wrapper">
          @if (item.hasBadge) {
            <div class="badge-container"></div>
          }
          @if (item.menuIcon.startsWith('https')) {
            <img [src]="item.menuIcon" />
          } @else {
            <i [class]="item.menuIcon"></i>
          }
        </div>
      </div>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayPositions]="railPositions"
      [cdkConnectedOverlayOpen]="item.tooltip"
    >
      <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
        {{ item.name ? item.name : item.labelName }}
      </div>
    </ng-template>
  }
</ng-template>

<!-- 【收缩时】菜单 subitem 模板 -->
<ng-template #railMenuSubItem let-menu="menu">
  @for (item of menu; track $index) {
    @if (item.infoExpandList && item.expand && item.redirectMethod == 'DropDownList') {
      @for (subItem of item.infoExpandList; track $index) {
        <ng-container *ngTemplateOutlet="railMenuItem; context: { item: subItem, level: 1 }"></ng-container>
      }
    }
  }
</ng-template>

<!-- 【收缩时】菜单项是选择列表时的模板 -->
<ng-template #railOptions let-item="item">
  <div class="rail-menu-item level1">
    <div class="options rail-options">
      @for (optionsItem of item.options; track $index) {
        <div
          [class]="optionsItem.class"
          cdkOverlayOrigin
          #origin="cdkOverlayOrigin"
          (click)="optionsItem.optionsExpand = !optionsItem.optionsExpand"
        >
          <img
            *ngIf="optionsItem.selectIcon"
            class="select-icon"
            [src]="optionsItem.options | filterByKeyValue: 'id' : optionsItem.select : 'menuIcon'"
          />
        </div>
        <ng-template
          cdkConnectedOverlay
          (overlayOutsideClick)="nextTick(optionsItem)"
          [cdkConnectedOverlayPositions]="railPositionsCenter"
          [cdkConnectedOverlayOpen]="optionsItem.optionsExpand"
          [cdkConnectedOverlayOrigin]="origin"
        >
          <div class="options-overlay-container">
            <div class="options-list">
              @for (listItem of optionsItem.options; track $index) {
                <div
                  class="options-item onact96"
                  [class.selected]="listItem.id === optionsItem.select"
                  (click)="$event.stopPropagation(); optionsSelect(optionsItem, listItem)"
                >
                  <img class="select-icon" [src]="listItem.menuIcon" />
                </div>
              }
            </div>
          </div>
        </ng-template>
      }
    </div>
  </div>
</ng-template>

<!-- 【收缩时】主题切换 -->
<ng-template #railThemeSwitch let-theme="theme" let-item="item">
  <div
    class="rail-a"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (mouseenter)="item.tooltip = true"
    (mouseleave)="item.tooltip = false"
    (click)="$event.stopPropagation(); $event.preventDefault(); railThemeSwitchComponent.toggle(theme === 'sun')"
  >
    <div class="rail-menu-item level1">
      <div>
        <i [class]="theme === 'sun' ? 'fi-sun-filled' : 'fi-moon-filled'"></i>
      </div>
    </div>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="railPositions"
    [cdkConnectedOverlayOpen]="item.tooltip"
  >
    <div class="rail-tooltip animate__animated animate__faster animate__fadeIn animate__fill_none">
      {{ item.name }}
    </div>
  </ng-template>
  <app-theme-switch
    #railThemeSwitchComponent
    [simple]="true"
    [simpleStyle]="'fill'"
    (click)="$event.stopPropagation(); $event.preventDefault()"
    style="display: none"
  ></app-theme-switch>
</ng-template>

<!--【扩展时】菜单 單獨/群組 item 模板分類 -->
<ng-template #menuItemCategory let-item="item" let-level="level" let-isFirst="isFirst">
  <!-- 如果不是隱藏 並且 (在手機版 或 網頁版但是沒有網頁隱藏) -->
  @if (!item.hide && (!item?.hideWeb || isH5)) {
    @if (item.infoExpandList?.length) {
      <div [ngClass]="{ 'menu-item-accordion': true, expanded: item.expand }">
        <ng-container
          *ngTemplateOutlet="menuItem; context: { item: item, level: level, isFirst: isFirst }"
        ></ng-container>
        @if (item.expand && item.redirectMethod == 'DropDownList') {
          @for (subItem of item.infoExpandList; track $index) {
            <ng-container
              *ngTemplateOutlet="menuItem; context: { item: subItem, level: level + 1, isFirst: isFirst }"
            ></ng-container>
          }
        }
      </div>
    } @else if (item.triggerChildren) {
      <div [ngClass]="{ 'menu-item-accordion': true, expanded: item.expand }">
        <ng-container
          *ngTemplateOutlet="menuItem; context: { item: item, level: level, isFirst: isFirst }"
        ></ng-container>
        @if (item.expand) {
          <ng-container
            *ngTemplateOutlet="menuItem; context: { item: item.triggerChildren, level: level + 1 }"
          ></ng-container>
        }
      </div>
    } @else {
      <ng-container
        *ngTemplateOutlet="menuItem; context: { item: item, level: level, isFirst: isFirst }"
      ></ng-container>
    }
  }
</ng-template>

<!-- 【扩展时】菜单 item 模板 -->
<ng-template #menuItem let-item="item" let-level="level" let-isFirst="isFirst">
  @switch (item.special) {
    @case (true) {
      @switch (item.ident) {
        @case ('theme-switch') {
          <ng-container
            [ngTemplateOutlet]="themeSwitch"
            [ngTemplateOutletContext]="{ theme: appService.themeSwitch$ | async, item: item, level: level }"
          ></ng-container>
        }
        @case ('langSelect') {
          <ng-container
            [ngTemplateOutlet]="langSelect"
            [ngTemplateOutletContext]="{ item: item, level: level }"
          ></ng-container>
        }
      }
    }

    @default {
      <a
        *ngIf="!checkDisabled(item)"
        [class]="'menu-item ' + (item.ident || '') + ' ' + (item.class || '') + ' level' + level"
        [class.expand]="item.expand"
        [class.has-children]="item.infoExpandList?.length"
        [class.has-bottom-border]="item.hasBotLine"
        [class.active]="item.activeRoutePath | routerActive: 'include'"
        (click)="$event.stopPropagation(); clickMenu(item); $event.preventDefault()"
        (press)="onPressMenu(item)"
        [href]="domain + '/' + appService.languageCode + miniGameService.getLinkByMethod(item)"
      >
        <div class="decorate"></div>
        <div class="left">
          <div class="badge-wrapper">
            <!-- @if (item.hasBadge) {
              <div class="badge-container"></div>
            } -->
            @if (item.menuIcon.startsWith('https')) {
              <img [src]="item.menuIcon" />
            } @else {
              <i [class]="item.menuIcon"></i>
            }
          </div>
          <span>{{ item.name ? item.name : item.labelName }}</span>
          <i *ngIf="item.trigger" [class.trigger-expand]="item.value" class="expand-icon icon-arrow-left-simple"></i>
          <ng-container *ngIf="item.options">
            <ng-container *ngTemplateOutlet="options; context: { item: item }"></ng-container>
          </ng-container>
        </div>
        <div class="right">
          @if (item.infoExpandList?.length && item.redirectMethod == 'DropDownList') {
            <cs-button
              [style.width.px]="30"
              size="small"
              color="third"
              (buttonClick)="$event.stopPropagation(); toggleDropdownItem(item); $event.preventDefault()"
            >
              <i class="expand-icon fi-cheveron-left"></i>
            </cs-button>
          }
          <div *ngIf="item?.num && (item?.num | async) as count" class="count-wrapper">
            <em>{{ count > 99 ? '99+' : count }}</em>
          </div>
        </div>
      </a>
    }
  }
</ng-template>

<!-- 【扩展时】菜单项是选择列表时的模板 -->
<ng-template #options let-item="item">
  <div class="options">
    @for (optionsItem of item.options; track $index) {
      <div
        [class]="optionsItem.class"
        cdkOverlayOrigin
        #origin="cdkOverlayOrigin"
        (click)="optionsItem.optionsExpand = !optionsItem.optionsExpand"
      >
        <i
          *ngIf="optionsItem.selectIcon"
          class="select-icon"
          [class]="optionsItem.options | filterByKeyValue: 'id' : optionsItem.select : 'menuIcon'"
        ></i>
        <span>{{ optionsItem.options | filterByKeyValue: 'id' : optionsItem.select : 'text' }}</span>
        <i class="options-icon icon-arrow-right-simple" [class.expand]="optionsItem.optionsExpand"></i>
      </div>
      <ng-template
        cdkConnectedOverlay
        (overlayOutsideClick)="nextTick(optionsItem)"
        [cdkConnectedOverlayPositions]="positions"
        [cdkConnectedOverlayOpen]="optionsItem.optionsExpand"
        [cdkConnectedOverlayOrigin]="origin"
      >
        <div class="options-overlay-container">
          <div class="options-list">
            @for (listItem of optionsItem.options; track $index) {
              <div
                class="options-item onact96"
                [class.selected]="listItem.id === optionsItem.select"
                (click)="$event.stopPropagation(); optionsSelect(optionsItem, listItem)"
              >
                <i *ngIf="listItem.menuIcon" [class]="listItem.menuIcon"></i>
                <span>{{ listItem.text }}</span>
              </div>
            }
          </div>
        </div>
      </ng-template>
    }
  </div>
</ng-template>

<!-- 【扩展时】語言切换 -->
<ng-template #langSelect let-item="item" let-level="level">
  <div [ngClass]="{ 'menu-item-accordion': true, expanded: item.expand }">
    <a
      [class]="'menu-item ' + (item.ident || '') + ' ' + (item.class || '') + ' level' + level"
      [class.expand]="item.expand"
      (click)="$event.stopPropagation(); $event.preventDefault(); toggleDropdownItem(item)"
    >
      <div class="decorate"></div>
      <div class="left">
        @for (optionsItem of item.options; track $index) {
          @for (listItem of optionsItem.options; track $index) {
            @if (optionsItem.select === listItem.id) {
              @if (optionsItem.selectIcon) {
                <img class="select-icon" [src]="listItem.menuIcon" />
              }
              <span>{{ listItem.text }}</span>
            }
          }
        }
      </div>
      <div class="right">
        <cs-button
          [style.width.px]="30"
          size="small"
          color="third"
          (buttonClick)="$event.stopPropagation(); $event.preventDefault(); toggleDropdownItem(item)"
        >
          <i class="expand-icon fi-cheveron-left"></i>
        </cs-button>
      </div>
    </a>
    @if (item.expand) {
      @for (optionsItem of item.options; track $index) {
        @for (listItem of optionsItem.options; track $index) {
          <a
            [class]="'onact96 menu-item ' + (item.ident || '') + ' ' + (item.class || '') + ' level' + level + 1"
            (click)="$event.stopPropagation(); $event.preventDefault(); optionsSelect(optionsItem, listItem)"
          >
            <div class="decorate"></div>
            <div class="left">
              @if (optionsItem.selectIcon) {
                <img class="select-icon" [src]="listItem.menuIcon" />
              }
              <span>{{ listItem.text }}</span>
            </div>
          </a>
        }
      }
    }
  </div>
</ng-template>

<!-- 【扩展时】主题切换 -->
<ng-template #themeSwitch let-theme="theme" let-item="item" let-level="level">
  <a
    *ngIf="!checkDisabled(item)"
    [class]="'onact96 menu-item ' + (item.ident || '') + ' ' + (item.class || '') + ' level' + level"
    [class.active]="item.activeRoutePath | routerActive: 'full'"
    (click)="$event.stopPropagation(); $event.preventDefault(); themeSwitchComponent.toggle(theme === 'sun')"
  >
    <div class="decorate"></div>
    <div class="left">
      <i [class]="theme === 'sun' ? 'fi-sun-filled' : 'fi-moon-filled'"></i>
      <span>{{ item.name }}</span>
    </div>
    <div class="right">
      <app-theme-switch
        #themeSwitchComponent
        [simple]="false"
        [simpleStyle]="'fill'"
        (click)="$event.stopPropagation()"
      ></app-theme-switch>
    </div>
  </a>
</ng-template>
